import { useContext } from "react";
import NonIdealNew from "../../common/NonIdealNew";
import { LanguageContext } from "../../../context/LanguageContext";
import { analytics, triggerLogEvent } from "../../../config/firebase";
import { useNavigate } from "react-router-dom";
import { Grid } from "@mui/material";
import { InnerWrapper, MainContainer, TitleAndActionBox } from "../../common";
import { UBButton } from "../../../Libraries";
import withObservables from "@nozbe/with-observables";
import {
  observeExpenseByBusinessCount,
} from "../../../database/helpers/invoice";
import { PlayIcon } from "../../../assets/icons/icon";
import { useAuthContext } from "../../../context/AuthContext";
import ExpenseList from "../../container/Expense/ExpenseList";
import { of } from "rxjs";

const QuickExpenses = ({ expenseListCount }) => {
  const [I18n] = useContext(LanguageContext);
  const navigate = useNavigate();
  const { business, user } = useAuthContext();

  const handleAddQuickExpense = () => {
    triggerLogEvent(analytics, "pne_exp");
    navigate("/Expense/ExpenseForm");
  };

  const isNonIdeal = expenseListCount <= 0;

  return (
    <MainContainer fluid className="quickSalePage">
      <Grid container>
        <Grid item md={12}>
          <TitleAndActionBox
            data={{
              title: I18n.quick_expense,
            }}
          >
            <UBButton
              onClick={handleAddQuickExpense}
              id={"create_quick_sale"}
              className="ubPrimaryButton fontSize12 fontWeight400 textUppercase marginLeft12"
              title={I18n.add_quick_expense}
            />
          </TitleAndActionBox>
          <InnerWrapper className="innerWrapper newInnerWrapper">
            {isNonIdeal ? (
              <NonIdealNew
                title={I18n.lost_in_expenses_stay_organized}
                subtitle={I18n.record_expense_as_soon_as}
                button1Title={"add_quick_expense"}
                // button2Title="watch_video"
                onButton1Click={handleAddQuickExpense}
                loading={false}
                disabledOne={false}
                disabledTwo={false}
                buttonOneId={"create_quick_sale"}
                buttonTwoId={"watch_video"}
                prefixIconButtonTwo={
                  <PlayIcon width="18px" height="18px" fill="var(--blue500)" />
                }
                video_footer={{
                  title: I18n.add_quick_expense,
                  onClick: handleAddQuickExpense,
                }}
                video_url={
                  "https://www.youtube.com/embed/KpMpGauNeDc?si=_xvfwB-A25WKNQO1"
                }
                videoTitle={I18n.lost_in_expenses_stay_organized}
                videoSubtitle={I18n.record_expense_as_soon_as}
              />
            ) : (
              <ExpenseList business={business} user={user} />
            )}
          </InnerWrapper>
        </Grid>
      </Grid>
    </MainContainer>
  );
};

const enhance = withObservables([], () => ({
  expenseListCount: observeExpenseByBusinessCount(
    localStorage.getItem("business_id") ,
  ) || of(0),
}));

export default enhance(QuickExpenses);
